import { normalizeSunoPlaceholdersForStorage } from "utils/suno-merge-tags.util";

/**
 * Exports the builder's HTML in the one merge-tag form the backend resolves inside a full HTML
 * document: `<!--SUNO:tag-->`.
 *
 * Unlayer strips the angle brackets off its registered merge-tag `value`, so its raw `exportHtml`
 * emits `!--SUNO:tag--`. The doctype branch of the backend's `ContextManager.format_template`
 * matches only the bracketed comment, so a raw `exportHtml` persists a token that silently never
 * substitutes — the patient receives a dead link (SN-19526).
 *
 * Always reach for this instead of calling `editor.exportHtml` directly. `normalizeSunoPlaceholders
 * ForStorage` is idempotent, so it is a no-op on a design that already holds the bracketed form.
 *
 * `design` is returned untouched on purpose: the design JSON carries Unlayer's own merge-tag
 * `value`, which has to stay bracket-less or the editor stops re-tokenising it into a chip on load.
 */
export const exportBuilderHtmlForStorage = (
  editor: UnlayerEditor
): Promise<{ html: string; design: UnlayerDesign }> =>
  new Promise((resolve) => {
    editor.exportHtml((data) => {
      resolve({
        html: normalizeSunoPlaceholdersForStorage(data.html),
        design: data.design
      });
    });
  });
